import script from "./ShopReconciliationList.vue?vue&type=script&lang=ts&setup=true&name=DeliveryList"
export * from "./ShopReconciliationList.vue?vue&type=script&lang=ts&setup=true&name=DeliveryList"

import "./ShopReconciliationList.vue?vue&type=style&index=0&id=19644b6b&lang=stylus&scoped=true"

import exportComponent from "/www/wwwroot/home/v-admin/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19644b6b"]])

export default __exports__